<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.QUESTIONNAIRE_GROUPS)}}</h2>
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="questionnaire-group-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="questionnaire-group-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>Id</label>
            <input class="form-control" [(ngModel)]="filter.uid"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.NAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.name"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>
          <div class="search-field span-2-columns">
            <label>{{_(KEYS.GRID.QUESTIONNAIRES)}}</label>
            <app-select2
              [hideLabel]="true"
              [hideButton]="true"
              [multiple]="true"
              [options]="{width: '100%', placeholder: '...'}"
              [(selected)]="filter.questionnaires"
              (selectedChange)="onFilterChange()"
            >
              <option *ngFor="let q of questionnaires" [value]="q.id">
                {{q.meta.title[locale] || q.meta.title[defaultLocale] || '???'}}
              </option>
            </app-select2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="questionnaire-group-grid-results">
          <span class="mm-pane-toggle-label"><i class="fa fa-copy" aria-hidden="true"></i><span>{{_(KEYS.GRID.QUESTIONNAIRE_GROUPS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      <div id="questionnaire-group-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col">{{_(KEYS.GRID.ID)}}</th>
            <th>{{_(KEYS.GRID.NAME)}}</th>
            <th>{{_(KEYS.GRID.QUESTIONNAIRES)}}</th>
            <th>{{_(KEYS.GRID.CREATED_AT)}}</th>
            <th>{{_(KEYS.GRID.UPDATED_AT)}}</th>
            <th>{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let group of groups; let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
              <td class="id-col">
                <span ngbTooltip="{{group.uid}}">{{group.uid | truncate: 5}}</span>
              </td>
              <td>
                <ng-container *ngIf="group?.name && group?.name[locale]">
                  {{group.name[locale]}}
                </ng-container>
              </td>
              <td>
                <ng-container *ngIf="group.questionnaires">
                  <ul>
                    <ng-container *ngFor="let questionnaire of group.questionnaires">
                      <li *ngIf="questionnaire?.meta?.title && questionnaire?.meta?.title[locale]">
                        {{questionnaire.meta.title[locale]}}
                      </li>
                    </ng-container>
                  </ul>
                </ng-container>
              </td>
              <td>
                {{group.createdAt | datex:dateFormat}}
              </td>
              <td>
                {{group.updatedAt | datex:dateFormat}}
              </td>
              <td>
                <div class="d-inline-block nowrap">
                  <div
                    class="btn btn-primary mr-1"
                    (click)="onEditGroup(group)"
                    data-toggle="tooltip" data-placement="top"
                    [title]="_(KEYS.GRID.CHANGE)"
                  >
                    <i class="fa fa-edit qa-cursor-pointer"></i>
                  </div>
                  <div
                    class="btn btn-danger"
                    (click)="onDeleteGroup(group)"
                    data-toggle="tooltip" data-placement="top"
                    [title]="_(KEYS.GRID.DELETE)">
                    <i class="fa fa-trash qa-cursor-pointer"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>
              <button
                class="btn btn-primary ml-1"
                (click)="onCreateGroup()"
                data-toggle="tooltip"
                data-placement="top"
                title="{{_(KEYS.GRID.CREATE)}}">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
